module.exports = __webpack_public_path__ + "img/ipad-jp-11.dac17f2.jpg";